import React, { useState } from 'react';
import { useTranslation } from 'react-i18next';
import { Badge, Button, Form, Space } from 'antd';
import { FilterOutlined } from '@ant-design/icons';
import type { ICargoFilter } from 'shared/stores/use-cargo-filters.ts';
import { useCargoFiltersStore } from 'shared/stores/use-cargo-filters.ts';
import { CargoFiltersSearch } from './components/cargo-filters-search';
import { CargosFiltersDrawer } from './components/cargos-filters-drawer';

export const CargosFilter: React.FC = () => {
  const { t } = useTranslation();
  const { filters, search } = useCargoFiltersStore();
  const [isOpen, setIsOpen] = useState(false);

  const [form] = Form.useForm<ICargoFilter>();

  const handleOpen = () => setIsOpen(true);
  const handleClose = () => setIsOpen(false);

  return (
    <>
      <Space size='small'>
        <CargoFiltersSearch />
        <Badge dot={!!filters}>
          <Button type='primary' icon={<FilterOutlined />} disabled={!!search} ghost onClick={handleOpen}>
            {t('common:filters')}
          </Button>
        </Badge>
      </Space>
      <CargosFiltersDrawer form={form} isOpen={isOpen} onClose={handleClose} />
    </>
  );
};
